import React, { useState } from "react";
import "../styles/Training.css"; // same CSS file
import { Award, Ban } from 'lucide-react';

// -------------------- TYPES --------------------
type Intern = {
  name: string;
  link?: string;
  qualified: boolean;
  program: string;
};

// -------------------- DATA --------------------
const internData: Record<string, Intern> = {
  AAFLTP0001: {
    name: "Christabel Essumang",
    link: "https://drive.google.com/uc?export=download&id=17Mu0flNMiylnQQYjVJv5-0LFr4la0nGt",
    qualified: true,
    program: "Leadership and Advocacy Training Program",
  },
  AAFLTP0010: {
    name: "Precious Kunadu Sarpong",
    link: "https://drive.google.com/uc?export=download&id=13WG9IsAwLR3b9xSNi3PFgMD89MogF05q",
    qualified: true,
    program: "Leadership and Advocacy Training Program",
  },
  AAFLTP0011: {
    name: "Elizabeth Boateng",
    link: "https://drive.google.com/uc?export=download&id=1N-pHda2vqHXs34sXejhZ7v76vtD64TRr",
    qualified: true,
    program: "Leadership and Advocacy Training Program",
  },
  AAFLTP0100: {
    name: "Samuel Adu",
    link: "https://drive.google.com/uc?export=download&id=17yCv28pngUT89itwFWOjsOTF8NMU2mBs",
    qualified: true,
    program: "Leadership and Advocacy Training Program",
  },
  AAFLTP0101: {
    name: "Abdul Hakeem Iddrisu",
    link: "https://drive.google.com/uc?export=download&id=1x8dY2YSBHQTPB0Paf0b4Ddj5un5f66Oz",
    qualified: true,
    program: "Leadership and Advocacy Training Program",
  },
  AAFLTP0110: {
    name: "Harriet Adomah",
    link: "https://drive.google.com/uc?export=download&id=1hnGNX2yc1lodk2ixt8-w0o4qCwwhnrd1",
    qualified: true,
    program: "Leadership and Advocacy Training Program",
  },
  AAFLTP0111: {
    name: "Pamela Akosua Serwaa Acheampong",
    link: "https://drive.google.com/uc?export=download&id=1Q-bdZXElQtbveqDZSAZDyxoIEfLyTt6M",
    qualified: true,
    program: "Leadership and Advocacy Training Program",
  },
  AAFLTP1000: {
    name: "Attipoe Hannah Mawutor",
    link: "https://drive.google.com/uc?export=download&id=1x1dBo_aQrC262B0-ApdhbdLg9GTBFbgT",
    qualified: true,
    program: "Leadership and Advocacy Training Program",
  },
  AAFLTP10101: {
    name: "Treku Raymond Apeti",
    link: "https://drive.google.com/uc?export=download&id=1pplTtImolXBxeHd4RKmS8djiMiCDC7GC",
    qualified: true,
    program: "Leadership and Advocacy Training Program",
  },
  AAFLTP1110: {
    name: "Eric Essien",
    link: "https://drive.google.com/uc?export=download&id=1NsTXRoULcu2KTu_6BrM4bxMezfZlyKIj",
    qualified: true,
    program: "Leadership and Advocacy Training Program",
  },
  AAFLTP1100: {
    name: "Perpetual Larbi",
    link: "https://drive.google.com/uc?export=download&id=12BN-ZtT5voErWn62i-a_uFjLqzGOow5Y",
    qualified: true,
    program: "Leadership and Advocacy Training Program",
  },
  AAFLTP11011: {
    name: "Andrew Cobby Asamoah",
    link: "https://drive.google.com/uc?export=download&id=12e94uHXfPW-G6h3BtqFDqaiJH0oCSmtT",
    qualified: true,
    program: "Leadership and Advocacy Training Program",
  },
  AAFLTP100001: {
    name: "Gifty Dede Anorhia Terkper",
    link: "https://drive.google.com/uc?export=download&id=1v2iwMa6Vr7haNsJV8-irBOS0iMGIMtB2",
    qualified: true,
    program: "Leadership and Advocacy Training Program",
  },
  AAFLTP100100: {
    name: "Samuella Boateng Opoku",
    link: "https://drive.google.com/uc?export=download&id=1VgpI4iJEBj6nUMer563MtCKEZSSBPb1z",
    qualified: true,
    program: "Leadership and Advocacy Training Program",
  },
  AAFLTP100101: {
    name: "Rose-Ann Etornam Ama Lotsu",
    link: "https://drive.google.com/uc?export=download&id=19xERnLaffqy-Mq6cpn3Cv8uUvDwwhbmI",
    qualified: true,
    program: "Leadership and Advocacy Training Program",
  },
  AAFLTP100110: {
    name: "Emmanuel IMANIRAGABA",
    link: "https://drive.google.com/uc?export=download&id=1f9XKkMsDn5WDGSGhapw-ssm-qAbDnOJt",
    qualified: true,
    program: "Leadership and Advocacy Training Program",
  },
  AAFLTP100111: {
    name: "Dorinda sakyi Amoah",
    link: "https://drive.google.com/uc?export=download&id=1IDHSp8tZhN96yBQwYPzRMln8QiU-P--A",
    qualified: true,
    program: "Leadership and Advocacy Training Program",
  },
  AAFLTP101000: {
    name: "Vera Naa Kwarley Quartey",
    link: "https://drive.google.com/uc?export=download&id=1eJU7Wg2SrPpTTKezS0LcDEAR8ZFD7j6X",
    qualified: true,
    program: "Leadership and Advocacy Training Program",
  },
  AAFLTP101001: {
    name: "Ephraim Kwateng Asamoah",
    link: "https://drive.google.com/uc?export=download&id=1u0K7BDFZqZOJpnf2_0qk2dfnP9KctYaM",
    qualified: true,
    program: "Leadership and Advocacy Training Program",
  },
  AAFLTP101101: {
    name: "⁠Emmanuel Sarfo Kantanka Kusi",
    link: "https://drive.google.com/uc?export=download&id=15ZmL1p-otcHYb0dO4ZsMBTTOcuNZrUcK",
    qualified: true,
    program: "Leadership and Advocacy Training Program",
  },
  AAFLTP101110: {
    name: "Joseph Yankson",
    link: "https://drive.google.com/uc?export=download&id=1i9Y6ZYmGXO_LxKqAvqx3_EtSDqKzRC6D",
    qualified: true,
    program: "Leadership and Advocacy Training Program",
  },

  //===============TESTING==============//
  AAFLTP11111: {
    name: "Addie's Afrique Foundation",
    link: "https://example.com/certificates/0011.pdf",
    qualified: true,
    program: "Leadership and Advocacy Training Program",
  },


  // Disqualified
  AAFLTP1001: { name: "Bangaly Sylla", qualified: false, program: "Leadership and Advocacy Training Program", },
  AAFLTP1010: { name: "Gideon Afari", qualified: false, program: "Leadership and Advocacy Training Program", },
  AAFLTP1011: { name: "Biantey Samuel Odei", qualified: false, program: "Leadership and Advocacy Training Program", },
  AAFLTP1101: { name: "Kingsley Blay", qualified: false, program: "Leadership and Advocacy Training Program", },
  AAFLTP1111: { name: "Wisdom Kwawuvi", qualified: false, program: "Leadership and Advocacy Training Program", },
  AAFLTP10000: { name: "Emmanuel Asare", qualified: false, program: "Leadership and Advocacy Training Program",  },
  AAFLTP10001: { name: "Solomon Bannor", qualified: false, program: "Leadership and Advocacy Training Program", },
  AAFLTP10010: { name: "Abdul-Rauf Yakubu", qualified: false, program: "Leadership and Advocacy Training Program", }, 
  AAFLTP10011: { name: "Boateng Evans", qualified: false, program: "Leadership and Advocacy Training Program", },
  AAFLTP10100: { name: "Oppong Kwarteng", qualified: false, program: "Leadership and Advocacy Training Program", },
  AAFLTP10110: { name: "Elorm Gabriel Mame...", qualified: false, program: "Leadership and Advocacy Training Program", }, 
  AAFLTP10111: { name: "Oppong Ellen Manu", qualified: false, program: "Leadership and Advocacy Training Program", },
  AAFLTP11000: { name: "Adongo Kenneth", qualified: false, program: "Leadership and Advocacy Training Program", },
  AAFLTP11001: { name: "Adusah Bonsu Immanuel",  qualified: false, program: "Leadership and Advocacy Training Program",},
  AAFLTP11010: { name: "Odjam Gabriel Tetteh", qualified: false, program: "Leadership and Advocacy Training Program", }, 
  AAFLTP11101: { name: "Bel Akosua Nyarko", qualified: false, program: "Leadership and Advocacy Training Program", },
  AAFLTP100000: { name: "Mattea Enam Azumah", qualified: false, program: "Leadership and Advocacy Training Program", },
  AAFLTP100010: { name: "Precious Oluomachi Nwachukwu", qualified: false, program: "Leadership and Advocacy Training Program", },
  AAFLTP100011: { name: "Josephine Ankomah", qualified: false, program: "Leadership and Advocacy Training Program", },
  AAFLTP101010: { name: "Emmanuella Oduro", qualified: false, program: "Leadership and Advocacy Training Program", },
  AAFLTP101100: { name: "Rose Yofaatey", qualified: false, program: "Leadership and Advocacy Training Program", },
  AAFLTP101111: { name: "Emmanuella Baaba Kwofie", qualified: false, program: "Leadership and Advocacy Training Program", },
  //===============TESTING==============//
  AAFLTP11110: { name: "Addie's Afrique Foundation", qualified: false, program: "Leadership and Advocacy Training Program", },


//Volunteer Training Program List
  AAFVTP0001: {
    name: "Owusu Boateng Nyarko",
    link: "https://drive.google.com/uc?export=download&id=1zeZTnQLmyF4XOeMVvAITjPmvcl5-rdRt",
    qualified: true,
    program: "Volunteer Training Program",
  },
  AAFVTP0010: {
    name: "Blessing Adiza Amaana",
    link: "https://drive.google.com/uc?export=download&id=1MW3K9BQ71Qezb9tGQcoLg8n_c9ppQm11",
    qualified: true,
    program: "Volunteer Training Program",
  },
  AAFVTP0011: {
    name: "Esther Akweley Apekor",
    link: "https://drive.google.com/uc?export=download&id=1yR5H-6n7fQ9GB0Gb0317XvgP6S1MTW3m",
    qualified: true,
    program: "Volunteer Training Program",
  },
  AAFVTP0100: {
    name: "Lovia Tettey",
    link: "https://drive.google.com/uc?export=download&id=1h3TT1MMVxvYstef9ADBGiLVVRltlGJcA",
    qualified: true,
    program: "Volunteer Training Program",
  },
  AAFVTP0101: {
    name: "Amoako Naana Afua Pokua",
    link: "https://drive.google.com/uc?export=download&id=1zTblCJrmf19uk4mWS-08CpQ15rFyyFAj",
    qualified: true,
    program: "Volunteer Training Program",
  },
  AAFVTP0110: {
    name: "Ephraim Kwateng Asamoah",
    qualified: false,
    program: "Volunteer Training Program",
  },
  AAFVTP0111: {
    name: "Cassandra Ntreh",
    qualified: false,
    program: "Volunteer Training Program",
  },
  AAFVTP1000: {
    name: "Sandra Akumaglo",
    qualified: false,
    program: "Volunteer Training Program",
  },
  AAFVTP10101: {
    name: "Abeyie Vanessa",
    qualified: false,
    program: "Volunteer Training Program",
  },
  AAFVTP1110: {
    name: "Nana N-suindin Jacob",
    qualified: false,
    program: "Volunteer Training Program",
  },
  AAFVTP1100: {
    name: "Elizabeth Ama Ewudzie",
    qualified: false,
    program: "Volunteer Training Program",
  },
  AAFVTP11011: {
    name: "Gifty Lawer",
    qualified: false,
    program: "Volunteer Training Program",
  },
};



// -------------------- COMPONENT --------------------
const TrainingCertificate: React.FC = () => {
  const [internId, setInternId] = useState("");
  const [currentIntern, setCurrentIntern] = useState<Intern | null>(null);
  const [showModal, setShowModal] = useState(false);

  // -------------------- LOGIC --------------------
  const showPopUp = () => {
    const trimmedId = internId.trim();

    if (trimmedId in internData) {
      setCurrentIntern(internData[trimmedId]);
      setShowModal(true);
    } else {
      alert("Invalid ID. Please try again.");
    }
  };

  const closePopUp = () => {
    setShowModal(false);
  };

  const triggerDownload = () => {
    if (currentIntern && currentIntern.qualified && currentIntern.link) {
      const link = document.createElement("a");
      link.href = currentIntern.link;
      link.download = `Certificate_${currentIntern.name}.pdf`;
      link.click();
      closePopUp();
    }
  };

  const contactManagement = () => {
    alert("Redirecting to the contact management page...");
    window.location.href =
      "https://addiesafriquefoundation.com/contact-us.html";
  };

  // -------------------- RENDER --------------------
  return (
    <>
      <div className="container">
        <section className="welcome-section">
          <div className="logo-container">
            <img src="/FLOGO.jpg" alt="Website Logo" />
          </div>

          <h1>Addie's Afrique Training Certification</h1>
          <p>Enter your ID to download your certificate</p>

          <div className="form-section">
            <input
              type="text"
              id="intern-id"
              placeholder="Enter your ID"
              value={internId}
              onChange={(e) => setInternId(e.target.value)}
            />
            <button onClick={showPopUp}>Submit</button>
          </div>
        </section>
      </div>

      {/* -------------------- MODAL -------------------- */}
      {showModal && currentIntern && (
        <div
          className="modal"
          id="certificate-modal"
          style={{ display: "flex" }}
        >
          <div className="modal-content">
            <span className="close-btn" onClick={closePopUp}>
              &times;
            </span>

            <div className="icon">
              <img src="/Certified.png" alt="Certified"
                id="award"
                style={{ display: currentIntern.qualified ? "block" : "none" }}
              />
              <img src="/NotCertified.png" alt="Not Certified"
                id="no-award"
                style={{ display: currentIntern.qualified ? "none" : "block" }}
              />
            </div>

            <p id="modal-message">
              {currentIntern.qualified ? (
                <>
                  CONGRATULATIONS <span className="name-highlight">{currentIntern.name}</span>! You've successfully
                  completed the{" "}
                  <strong>
                    Addie's Afrique Foundation {currentIntern.program}
                  </strong>
                  . Click below to download your well-deserved certificate and
                  celebrate your achievement!
                </>
              ) : (
                <>
                  Sorry {currentIntern.name}, you are not eligible for a
                  certificate due to inconsistencies in participation. Contact
                  management if this was a mistake.
                </>
              )}
            </p>

            <div className="center-it">
              {currentIntern.qualified ? (
                <button id="download-btn" onClick={triggerDownload}>
                  Download Certificate <i className="fa-solid fa-download"></i>
                </button>
              ) : (
                <button id="contact-btn" onClick={contactManagement}>
                  Contact Us
                </button>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default TrainingCertificate;
